import type { Placement } from "@floating-ui/react";

import type { PopupPosition } from "./Popup.types";

const POSITION_MAP: Record<PopupPosition, Placement> = {
  "top left": "top-start",
  "top center": "top",
  "top right": "top-end",
  "bottom left": "bottom-start",
  "bottom center": "bottom",
  "bottom right": "bottom-end",
  "left center": "left",
  "right center": "right",
};

export function mapPopupPosition(
  position: PopupPosition | undefined,
): Placement {
  if (!position) {
    return "top";
  }
  return POSITION_MAP[position] ?? "top";
}
